import { Component, Input, OnInit, ViewChild} from '@angular/core';
import { SwiperOptions } from 'swiper';
import { environment } from '../../../environments/environment';
import { DocumentService } from '../../services/document.service';
import { Router } from '@angular/router';
import { AppDataService } from '../../services/app-data.service';
import { InitializerService } from '../../services/initializer.service';
import { SwiperComponent } from 'ngx-useful-swiper';

@Component({
    selector: 'my-portal-images',
    templateUrl: './images.component.html',
    styleUrls: ['./images.component.scss'],
})
export class ImagesComponent implements OnInit {
    @Input() images: any;
    @Input() roomId: any;
    @Input() allotment: any;
    @Input() galleryItem: any;
    @Input() unavailable: any;
    slicedImages: any[] = [];
    slidesMap: Map<number, any[]> = new Map();
    currentSlideMapIndex = 0;

    slideIndex = 0;
    config: SwiperOptions = {
        autoplay: true,
        effect: 'fade',
        pagination: { el: '.images-pagination', clickable: true },
        autoHeight: true,
        allowTouchMove: true,
        slidesPerView: 1,
        loop: true,
        on: {
            click: () => this.onSlideClick(),
        }
    };
    isSafari: any = this.initializerService.isSafari();

    imgServer: string = environment.IMAGES_ENDPOINT;
    imgServerUrlEnd: any;

    @ViewChild(SwiperComponent) swiperRef?: SwiperComponent;

    constructor(
        private documentService: DocumentService,
        private router: Router,
        private appService: AppDataService,
        private initializerService: InitializerService
    ) {}

    ngOnInit(): void {
        if (this.images.length >= 10) {
            this.config.on = {
                click: () => this.onSlideClick(),
                slideChange: () => this.onSlideChange(),
            };
            this.config.pagination = { el: '.images-pagination', clickable: true, dynamicBullets: true, dynamicMainBullets: 5 };

            this.slidesMap = this.generateChunks(this.images, 5);
            this.updateSlide(0);
        }

        this.imgServerUrlEnd = this.initializerService.setImageQuality(environment.IMAGES_END_URL);
    }

    openModal(): void {
        if (this.documentService.getWindow()?.document.querySelector('header.fixed')) {
            (this.documentService.getWindow()?.document.querySelector('header.fixed') as HTMLElement).style.zIndex = '1';
        }
        (<any>this.documentService.getWindow()?.document.getElementById(`imgModal-${this.roomId}`)).style.display = 'block';
    }

    closeModal(): void {
        (<any>this.documentService.getWindow()?.document.getElementById(`imgModal-${this.roomId}`)).style.display = 'none';
        if (this.documentService.getWindow()?.document.querySelector('header.fixed')) {
            (this.documentService.getWindow()?.document.querySelector('header.fixed') as HTMLElement).style.zIndex = '2';
        }
    }

    onSlideClick() {
        const swiperInstance = this.swiperRef?.swiper;

        if (swiperInstance) {
            const realIndex = swiperInstance.realIndex;

            this.openModal();
            this.currentSlide(realIndex + 1);
        }
    }

    plusSlides(n: number): void {
        this.showSlides((this.slideIndex += n));
    }

    currentSlide(n: number): void {
        this.showSlides((this.slideIndex = n));
    }

    showSlides(n: number): void {
        let i;

        const slides = this.documentService
            .getWindow()
            ?.document.getElementsByClassName(`img-slides-${this.roomId}`) as HTMLCollectionOf<HTMLElement>;

        const dots = this.documentService.getWindow()?.document.getElementsByClassName('images') as HTMLCollectionOf<HTMLElement>;

        if (n > slides.length) {
            this.slideIndex = 1;
        }
        if (n < 1) {
            this.slideIndex = slides.length;
        }
        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = 'none';
        }
        slides[this.slideIndex - 1].style.display = 'block';
    }

      updateSlicedImages(index: number) {
        const total = this.images.length;
        const arraySize = 5;

        let start = index - Math.floor(arraySize / 2);
        let end = start + arraySize;

        if (start < 0) {
            start = 0;
            end = Math.min(arraySize, total);
        }

        if (end > total) {
            end = total;
            start = Math.max(0, end - arraySize);
        }

        this.slicedImages = this.images.slice(start, end);
    }

    generateChunks(array: any[], size: number): Map<number, any[]> {
        const map = new Map<number, any[]>();
        for (let i = 0; i < array.length; i += size) {
            map.set(i / size, array.slice(i, i + size));
        }
        return map;
    }

    updateSlide(index: number) {
        const slides = this.slidesMap.get(index);
        if (slides && this.slicedImages.length < this.images?.length) {
            this.currentSlideMapIndex = index;
            this.slicedImages.push(...slides);
        }
    }

    onSlideChange() {
        const totalSlides = this.slidesMap.size;
        const nextSlide = (this.currentSlideMapIndex + 1) % totalSlides;
        this.updateSlide(nextSlide);
    }

}
